import { render } from "./TrixField.vue?vue&type=template&id=e72273f4"
import script from "./TrixField.vue?vue&type=script&lang=js"
export * from "./TrixField.vue?vue&type=script&lang=js"

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TrixField.vue"]])

export default __exports__